export default "__VITE_ASSET__CShx1EZk__"